import React from 'react'
import Boron from 'boron'
import styles from './styles.css'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import {Form, Field} from 'simple-react-form'
import Toggle from 'orionsoft-parts/lib/components/fields/Toggle'
import Icon from './Icon'

export default class SecuritySatModal extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    icon: PropTypes.string
  }

  state = {icam: false, cto: false}

  toggleDialog(ref) {
    return this.refs[ref].toggle()
  }

  onClick(icam, cto) {
    this.props.onClick(icam, cto)
    this.toggleDialog('DropModal')
  }

  hideModal() {
    this.toggleDialog('DropModal')
  }

  getContent(modalName) {
    return (
      <div className={styles.container}>
        <div className="row center-sm">
          <div className="col-xs-12 col-sm-12">
            <div className={styles.logo}>
              <Icon icon={'DocCreate'} />
            </div>
          </div>
        </div>
        <p className={styles.landingText}>
          Se creará el documento con los datos de esta preparación. A continuación debes seleccionar
          cuales anexos quieres agregar a la creación.{' '}
        </p>
        <div className={styles.form}>
          <Form state={this.state} onChange={changes => this.setState(changes)}>
            <Field label="Agregar anexo ICAM" fieldName="icam" type={Toggle} />
            <Field label="Agregar anexo CTO " fieldName="cto" type={Toggle} />
          </Form>
        </div>
        <p className={styles.landingText}>Para continuar selecciona 'confirmar'.</p>
        <div className="row center-sm">
          <div className="col-xs-12 col-sm-2" />
          <div className="col-xs-12 col-sm-4">
            <Button primary onClick={() => this.onClick(this.state.icam, this.state.cto)}>
              Confirmar
            </Button>
          </div>
          <div className="col-xs-12 col-sm-4">
            <Button onClick={() => this.hideModal()}>Cancelar</Button>
          </div>
          <div className="col-xs-12 col-sm-2" />
        </div>
      </div>
    )
  }

  render() {
    const Modal = Boron['DropModal']
    return (
      <div className={styles.container}>
        <Modal ref={'DropModal'}>{this.getContent('DropModal')}</Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/SecuritySatModal/index.js